<template>
  <b-card class="mt-4" no-body role="tablist">
    <table class="table table-hover">
      <thead>
        <th :style="{ width: '40%' }">Nazwa firmy</th>

        <th :style="{ width: '30%' }">Liczba pracowników</th>

        <th :style="{ width: '30%' }" class="text-right">
          <b-btn @click="add = true" size="sm" variant="outline-primary">Dodaj</b-btn>
        </th>
      </thead>

      <tbody>
        <tr v-show="add">
          <td>
            <b-form-group class="mb-0">
              <app-input :model="$schema.companyName" />
            </b-form-group>
          </td>

          <td></td>

          <td class="text-right">
            <b-btn @click="add = false" variant="outline-secondary">Anuluj</b-btn>

            <b-btn @click="
                addCompany();
              " variant="primary">Dodaj</b-btn>
          </td>
        </tr>

        <tr v-for="company in companies" :key="company.id">
          <td>{{ company.name }}</td>

          <td>{{ company.cards.length }}</td>

          <td class="text-right">
            <b-dropdown
              size="sm"
              split
              text="Edytuj"
              variant="outline-primary"
              @click="showModal(company.id, company.name)"
            >
              <b-dropdown-item @click="removeCompany(company.id, company.name)">Usuń</b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal
      v-model="editModal"
      title="Edycja nazwy firmy"
      @ok="editCompany"
      @cancel="
        $schema.companyName.$model = '';
        editId = null;
      "
      ok-title="Zapisz"
      cancel-title="Anuluj"
    >
      <b-form-group class="mb-0">
        <app-input :model="$schema.companyName" />
      </b-form-group>
    </b-modal>

    <loader :show="showLoader" />
  </b-card>
</template>

<script>
import loader from '../../components/Loader.vue';
import formMixin from '@/mixins/formMixin';
import schema from '@/schemas/company.schema';
import { CompanyResource } from '@/resources/company.resource';

export default {
  components: { loader },
  mixins: [formMixin],
  schema,
  data() {
    return {
      companies: [],
      employees: [],
      showLoader: true,
      add: false,
      editModal: false,
      modalData: {}
    };
  },
  methods: {
    async addCompany() {
      if (this.$schema.$validateAll().length > 0) {
        this.$notify({ type: 'error', title: 'Błąd', text: 'Błędnie wypełniony formularz' });
        return;
      }
      const company = await CompanyResource.add(this.$schema.$model.companyName);
      this.add = false;
      this.companies.push(company);
      this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie dodano firmę' });
    },
    async removeCompany(id, name) {
      try {
        if (!confirm('Czy napewno chcesz usunąć firmę ' + name)) {
          return;
        }
        await CompanyResource.delete(id);
        this.companies.splice(this.companies.findIndex(company => company.id === id), 1);
        this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie usunięto firmę' });
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas usuwania firmy' });
      }
    },
    showModal(id, name) {
      this.$schema.$model.companyName = name;
      this.editId = id;
      this.editModal = true;
    },
    async editCompany() {
      try {
        if (this.$schema.$validateAll().length > 0) {
          this.$notify({ type: 'error', title: 'Błąd', text: 'Błędnie wypełniony formularz' });
          return;
        }
        const updatedCompany = await CompanyResource.update(this.editId, this.$schema.$model.companyName);
        this.$set(this.companies, this.companies.findIndex(company => company.id === this.editId), updatedCompany);
        this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie zaktualizowano firmę' });
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas edytowania firmy' });
      }
    }
  },
  async beforeMount() {
    this.companies = await CompanyResource.list();
    this.showLoader = false;
  }
};
</script>

<style>
form {
  margin: auto;
  max-width: 400px;
}
</style>
